<template>
  <div>
    <!-- UPLOAD DOCUMENT DIALOG -->
    <UploadDocument
      v-if="files.length > 0"
      :folder="folder"
      :files="files"
      :icons="{}"
      :maxUploadFilesCount="maxFilesCount"
      :maxUploadFileSize="maxFileSize"
      v-on:add-files="add"
      v-on:remove-file="remove"
      v-on:clear-files="clear"
      v-on:cancel="clear"
      v-on:uploaded="uploaded"
    />

    <!-- Hidden File Input -->
    <input
      v-show="false"
      ref="inputUpload"
      type="file"
      multiple
      @change="onInputChange"
    />
  </div>
</template>

<script>
import UploadDocument from "./UploadDocument.vue"

export default {
  name: "DialogFileUpload",
  components: { UploadDocument },
  props: {
    folder: {
      type: Object
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      files: [],
      maxFileSize: 0,
      maxFilesCount: 0
    }
  },
  methods: {
    onInputChange(event) {
      this.add(event.target.files)
      this.$refs.inputUpload.value = ""
    },
    add(newValue) {
      let newFiles = Array.from(newValue)

      // filter too large files (avoid uploading too many files)
      const sizeLimit = this.maxFileSize
      if (sizeLimit > 0) {
        newFiles = newFiles.filter(file => file.size <= sizeLimit)
      }

      // filter too many files (avoid uploading too much files)
      const lenLimit = this.maxFilesCount - this.files.length
      if (this.maxFilesCount && newFiles.length > lenLimit) {
        newFiles = newFiles.slice(0, lenLimit)
      }

      // add remaining files
      this.files.push(...newFiles)
    },
    clear() {
      this.files = []
    },
    open() {
      this.$refs.inputUpload.click()
      this.$emit("input", false)
    },
    remove(index) {
      this.files.splice(index, 1)
    },
    uploaded() {
      this.clear()
      this.$emit("close", true)
    }
  },
  mounted() {
    if (this.value) this.open()
  },
  watch: {
    value: {
      handler(newValue, oldValue) {
        if (newValue) this.open()
      }
    }
  }
}
</script>
